import { reqGetCurrentUser } from "../request/ucenterapi/uc/internal/common/getCurrentUser/get.js";
import { reqGetUserMenuListByUserId } from "../request/ucenterapi/uc/internal/common/getUserMenuListByUserId/get.js";
import { ref } from "vue-demi";
const permissionMap = new Map();
async function getPermissionList(platformType) {
  const user = await reqGetCurrentUser();
  const menuList = await reqGetUserMenuListByUserId({ userId: user.id, platformType });
  return menuList;
}
function getPermissionListSync(platformType) {
  const permissionList = permissionMap.get(platformType);
  if (!permissionList) {
    const mapItem = ref([]);
    permissionMap.set(platformType, mapItem);
    getPermissionList(platformType).then((m) => mapItem.value = m);
  }
  return permissionMap.get(platformType) || ref([]);
}
function checkMenuPermissionSync(arg, userPlatformType) {
  var _a;
  const platformType = userPlatformType || "MTDS";
  const permissionList = getPermissionListSync(platformType);
  const argKeys = Object.keys(arg);
  return !!((_a = permissionList.value) == null ? void 0 : _a.some((p) => {
    return argKeys.every((k) => p[k] === arg[k]);
  }));
}
export { checkMenuPermissionSync, getPermissionList, getPermissionListSync };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/checkMenuPermission.js